/* eslint-disable */
import createIcon from '../createIcon';

const IconDownOutlined = createIcon({
  name: 'icon-down-outlined',
  content: '<path d="M511.681 702.208h.638l315.42-315.42-45.88-45.242-270.178 270.178-270.178-270.178-45.242 45.242 315.42 315.42z"/>',
  width: 1024,
  height: 1024
});
export default IconDownOutlined;
